<template>
  <section>
    <div class="header-details">
      <h1>Project Description</h1>
      <font-awesome-icon icon="arrow-right" class="icon-title" />
      <h1>Analysis of hydraulicfracturing operation</h1>
    </div>
    <hr />
    <div class="container-details">
      <div id="style-1" class="section overflow-content">
        <CardInfoVue />
      </div>
      <div class="section">
        <div class="toggle-map" :class="!map ? 'close' : ''" @click="ToggleMap">
          Map<font-awesome-icon class="icon-toggle-map" icon="caret-right" />
        </div>
        <MapVue :show="map" :lng="-46.33361" :lat="-23.96083" :zoom="9" />
      </div>
    </div>
  </section>
</template>

<script>
import CardInfoVue from "../components/ProyectDetails/CardInfo.vue";
import MapVue from "../components/ProyectDetails/Map.vue";
export default {
  components: {
    CardInfoVue,
    MapVue,
  },
  data: () => ({
    map: true,
  }),
  methods: {
    ToggleMap() {
      this.map = !this.map;
    },
  },
};
</script>

<style>
.header-details {
  display: flex;
  align-items: baseline;
}
.header-details .icon-title {
  color: var(--third-color);
  font-size: 1.5rem;
  margin: 0 10px;
  align-self: flex-end;
  transform: translateY(2.5px);
}
.header-details h1:first-child {
  font-weight: bold;
}
.header-details h1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  margin-bottom: 0;
}
.container-details {
  display: flex;
  width: 100%;
  justify-content: center;
}
.container-details .section {
  width: 55%;
  height: 70vh;
  margin: 0 15px;
  transition: 0.5s;
}
.overflow-content {
  overflow-y: scroll;
  padding: 15px 5px;
}

.toggle-map {
  display: none;
}

/*=============================================
ESCRITORIO PEQUEÑO O TABLET VERTICAL (SM revisamos en 768px)
=============================================*/

@media (max-width: 991px) and (min-width: 768px) {
  .container-details {
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    padding: 0 0 100px 0;
  }
  .container-details .section {
    width: 100%;
    height: auto;
    margin: 15px 0;
  }
  .overflow-content {
    overflow-y: hidden;
    padding: 15px 5px;
    height: auto;
  }
  .toggle-map {
    display: block;
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    color: var(--sixth-color);
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 1rem;
    cursor: pointer;
  }

  .toggle-map .icon-toggle-map {
    transform: rotate(90deg) translate(2.5px);
    font-size: 1.5rem;
    margin-left: 5px;
    transition: 0.5s;
  }
  .toggle-map.close .icon-toggle-map {
    transform: rotate(-90deg);
    transition: 0.5s;
  }
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/

@media (max-width: 767px) {
  .header-details .icon-title {
    color: var(--third-color);
    font-size: 1.5rem;
    align-self: flex-end;
    transform: translateY(-20px);
  }
  .container-details {
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    padding: 0 0 50px 0;
  }
  .container-details .section {
    width: 100%;
    height: auto;
    margin: 15px 0;
  }
  .overflow-content {
    overflow-y: hidden;
    padding: 15px 5px;
    height: auto;
  }

  .toggle-map {
    display: block;
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    color: var(--sixth-color);
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 1rem;
    cursor: pointer;
  }

  .toggle-map .icon-toggle-map {
    transform: rotate(90deg) translate(2.5px);
    font-size: 1.5rem;
    margin-left: 5px;
    transition: 0.5s;
  }
  .toggle-map.close .icon-toggle-map {
    transform: rotate(-90deg);
    transition: 0.5s;
  }
}
</style>